import React from 'react';
import { useField, FieldInputProps, FieldRenderProps } from 'react-final-form';
import { Radios } from '@teetsh/app/src/components/Form/Radios/formWrapper';

interface Props extends FieldRenderProps<string> {
  label: string;
  options: Array<{ label: string; value: string }>;
  input: FieldInputProps<string>;
}

export function ClassroomsSelector(props: Props) {
  const { input, ...rest } = props;
  const groupName = useField('groupName');
  return (
    <Radios
      {...rest}
      input={{
        ...input,
        onChange: v => {
          groupName.input.onChange(
            props.options.find(o => o.value === v)?.label,
          );
          return input.onChange(v);
        },
      }}
    />
  );
}
